import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { BreadcrumbItem } from '@/types/common'

export interface ToastCta {
  label: string
  action: () => void
}

export interface ToastOptions {
  duration?: number
  cta?: ToastCta
}

export interface ToastMessage {
  id: string
  message: string
  type: 'success' | 'error' | 'warning' | 'info'
  cta?: ToastCta
}

export const useUiStore = defineStore('ui', () => {
  const sidebarOpen = ref(false)
  const breadcrumbs = ref<BreadcrumbItem[]>([])
  const toasts = ref<ToastMessage[]>([])

  function openSidebar() {
    sidebarOpen.value = true
  }

  function closeSidebar() {
    sidebarOpen.value = false
  }

  function setBreadcrumbs(items: BreadcrumbItem[]) {
    breadcrumbs.value = items
  }

  function showToast(
    message: string,
    type: ToastMessage['type'] = 'info',
    options?: ToastOptions | { duration?: number },
  ) {
    const id = `toast-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`
    const duration = options?.duration ?? 5000
    const cta = (options as ToastOptions)?.cta
    toasts.value.push({ id, message, type, ...(cta ? { cta } : {}) })
    setTimeout(() => removeToast(id), duration)
  }

  function removeToast(id: string) {
    toasts.value = toasts.value.filter((t) => t.id !== id)
  }

  return {
    sidebarOpen, breadcrumbs, toasts,
    openSidebar, closeSidebar, setBreadcrumbs, showToast, removeToast,
  }
})
